import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { getStaffList } from "../Actions/StaffManagementAPI";
import { normalizeShipStaffRecord } from "../helpers/shipStaffNormalize";
import "./UserManagementMaster.css";

const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const defaultSearchData = {
  Name: "",
  PageNumber: 1,
  PageSize: 15,
};

class StaffManagementEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      saving: false,
      staffInfo: {
        shipStaffId: 0,
        name: "",
        phone: "",
        email: "",
        address: "",
        isDeleted: false,
        createdBy: currentUser?.name || "",
        createdDate: "",
        modifiedBy: currentUser?.name || "",
        modifiedDate: "",
      },
      fieldErrors: {
        name: "",
        email: "",
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    const { match, dispatch, t, StaffDetails } = this.props;
    const staffId = match.params.id;
    const isCreateMode = !staffId;

    dispatch({
      type: "SubBannerTitle",
      data: (
        isCreateMode
          ? t("StaffManagementScreenContent.AddStaff")
          : t("StaffManagementScreenContent.EditStaff")
      ).toUpperCase(),
    });
    dispatch({ type: "ShowSidePan", data: false });

    if (!isCreateMode) {
      if (StaffDetails && String(StaffDetails.shipStaffId) === String(staffId)) {
        this.applyStaffData(normalizeShipStaffRecord(StaffDetails));
      } else {
        this.loadStaff(staffId);
      }
    }
  }

  isCreateMode() {
    return !this.props.match.params.id;
  }

  applyStaffData(staff) {
    this.setState({
      staffInfo: {
        shipStaffId: staff.shipStaffId || 0,
        name: staff.name,
        phone: staff.phone,
        email: staff.email,
        address: staff.address,
        isDeleted: false,
        createdBy: staff.createdBy || currentUser?.name || "",
        createdDate: "",
        modifiedBy: currentUser?.name || "",
        modifiedDate: "",
      },
      loading: false,
    });
  }

  loadStaff(shipStaffId) {
    this.setState({ loading: true });

    axios
      .get(
        `${API.getShipStaffs}?Name=&PageNumber=1&PageSize=500`
      )
      .then((response) => {
        const list = response.data?.data || [];
        const found = list.find(
          (item) => String(item.shipStaffId) === String(shipStaffId)
        );
        if (found) {
          this.applyStaffData(normalizeShipStaffRecord(found));
        } else {
          this.setState({ loading: false });
          toast.error(this.props.t("CommonText.500ErrorMessage"));
          this.props.history.push("/Home/Management/Staff");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        toast.error(this.props.t("CommonText.500ErrorMessage"));
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    let nextValue = value;

    if (name === "phone") {
      const input = e.target;
      nextValue = input.validity.valid ? value : this.state.staffInfo.phone;
    }

    this.setState((prevState) => ({
      staffInfo: {
        ...prevState.staffInfo,
        [name]: nextValue,
      },
      fieldErrors: {
        ...prevState.fieldErrors,
        [name]: "",
      },
    }));
  }

  validateForm(t) {
    const { staffInfo } = this.state;
    const fieldErrors = {
      name: "",
      email: "",
    };

    if (!(staffInfo.name || "").trim()) {
      fieldErrors.name = t("ErrorMessage.RequiredMsg");
    }

    if (!(staffInfo.email || "").trim()) {
      fieldErrors.email = t("MMPLUserManagementContent.Emailismandatory");
    }

    this.setState({ fieldErrors });
    return !fieldErrors.name && !fieldErrors.email;
  }

  handleCancel() {
    this.props.history.push("/Home/Management/Staff");
    window.scrollTo(0, 0);
  }

  createStaff() {
    const { dispatch, t, history } = this.props;
    const { staffInfo } = this.state;

    this.setState({ saving: true });

    const payload = {
      name: staffInfo.name,
      phone: staffInfo.phone,
      email: staffInfo.email.trim(),
      address: staffInfo.address,
      createdBy: staffInfo.createdBy,
      createdDate: "",
    };

    axios
      .get(`${API.userExist}?Mail=${encodeURIComponent(payload.email)}`, {
        headers: { key: currentUser.accessToken },
      })
      .then((existResponse) => {
        if (existResponse.data !== true) {
          this.setState({ saving: false });
          toast.warning(t("ShipManagementContent.UserWaringMsg"));
          return;
        }

        axios
          .post(API.postShipStaff, payload, {
            headers: { key: currentUser.accessToken },
          })
          .then(() => {
            dispatch(getStaffList(defaultSearchData));
            toast.success(t("CommonText.CommonAdd"));
            history.push("/Home/Management/Staff");
            window.scrollTo(0, 0);
            this.setState({ saving: false });
          })
          .catch(() => {
            this.setState({ saving: false });
            toast.error(t("CommonText.500ErrorMessage"));
          });
      })
      .catch(() => {
        this.setState({ saving: false });
        toast.error(t("CommonText.500ErrorMessage"));
      });
  }

  updateStaff() {
    const { dispatch, t, history } = this.props;
    const { staffInfo } = this.state;

    this.setState({ saving: true });

    const payload = {
      shipStaffId: staffInfo.shipStaffId,
      name: staffInfo.name,
      phone: staffInfo.phone,
      email: staffInfo.email,
      address: staffInfo.address,
      isDeleted: false,
      modifiedBy: staffInfo.modifiedBy,
      modifiedDate: "",
    };

    axios
      .put(API.putShipStaff, payload, {
        headers: { key: currentUser.accessToken },
      })
      .then(() => {
        dispatch(getStaffList(defaultSearchData));
        toast.success(t("CommonText.CommonUpdate"));
        history.push("/Home/Management/Staff");
        window.scrollTo(0, 0);
        this.setState({ saving: false });
      })
      .catch(() => {
        this.setState({ saving: false });
        toast.error(t("CommonText.500ErrorMessage"));
      });
  }

  handleSave() {
    const { t } = this.props;
    if (!this.validateForm(t)) {
      return;
    }

    if (this.isCreateMode()) {
      this.createStaff();
    } else {
      this.updateStaff();
    }
  }

  renderFormField(label, name, placeholder, iconClass, type = "text", required = false, pattern) {
    const error = this.state.fieldErrors[name];

    return (
      <div className={`col-lg-3 col-md-6 col-12 um-filter-field${error ? " has-error" : ""}`}>
        <label className="form-label">
          {label}
          {required ? <span className="um-required">*</span> : null}
        </label>
        <div className={`um-input-shell${error ? " is-invalid" : ""}`}>
          <span className="um-input-icon">
            <i className={`fa ${iconClass}`} aria-hidden="true"></i>
          </span>
          <input
            className="form-control"
            type={type}
            name={name}
            placeholder={placeholder}
            value={this.state.staffInfo[name]}
            onChange={this.handleChange}
            pattern={pattern}
            aria-invalid={error ? "true" : "false"}
          />
        </div>
        {error ? (
          <div className="um-field-error" role="alert">
            <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
            <span>{error}</span>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const { loading, saving } = this.state;
    const isCreateMode = this.isCreateMode();

    if (loading) {
      return (
        <div className="full-height user-module-master um-edit-page">
          <div className="um-empty-state pt-5">Loading...</div>
        </div>
      );
    }

    return (
      <div className="full-height user-module-master um-edit-page">
        <div className="pt-3">
          <button
            type="button"
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue um-return-btn"
            onClick={this.handleCancel}
          >
            <span>&larr;</span>
            {t("CommonText.Return")}
          </button>

          <div className="um-section">
            <div className="um-section-header">
              <h5 className="um-section-title">
                <i className="fa fa-user um-section-title-icon" aria-hidden="true"></i>
                {t("EquipmentManagementScreenContent.BasicInformation")}
              </h5>
            </div>
            <div className="um-section-body">
              <div className="row um-form-grid">
                {this.renderFormField(
                  t("EquipmentManagementScreenContent.Name"),
                  "name",
                  t("EquipmentManagementScreenContent.Name"),
                  "fa-user",
                  "text",
                  true
                )}
                {this.renderFormField(
                  t("ServicedByScreenContent.Email"),
                  "email",
                  t("ServicedByScreenContent.Email"),
                  "fa-envelope-o",
                  "email",
                  true
                )}
                {this.renderFormField(
                  t("ClientManagementScreenContent.Phone"),
                  "phone",
                  t("ClientManagementScreenContent.Phone"),
                  "fa-phone",
                  "text",
                  false,
                  "[0-9]*"
                )}
                {this.renderFormField(
                  t("ClientManagementScreenContent.Address"),
                  "address",
                  t("ClientManagementScreenContent.Address"),
                  "fa-map-marker"
                )}
              </div>
            </div>
          </div>

          <div className={`um-form-actions${saving ? " is-saving" : ""}`}>
            <button
              type="button"
              className="btn btn-primary text-uppercase um-btn um-btn-primary"
              onClick={this.handleSave}
              disabled={saving}
            >
              {isCreateMode
                ? t("ComplianceandBudgetScreen.Submit")
                : t("EquipmentServiceTypes.Update")}
            </button>
            <button
              type="button"
              className="btn btn-light text-uppercase um-btn um-btn-secondary"
              onClick={this.handleCancel}
              disabled={saving}
            >
              {t("ComplianceandBudgetScreen.Cancel")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    StaffDetails: state.MasterScreenReducer.StaffDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(StaffManagementEdit))
);
